import { FiltroUnidadeComPessoas } from 'core/features/unidades/typings/unidade';
import { useCallback, useState } from "react";
import { BaseFiltroPaginate } from "resources/enums/paginate";


const defaultFiltro: FiltroUnidadeComPessoas = {
  page: 1,
    limit: BaseFiltroPaginate.Limit,
    search: "",
    pessoaAtivo: undefined,

}

function useFiltroConsultarPessoasEUnidades() {
  const [filtro, setFiltro] = useState<FiltroUnidadeComPessoas>(defaultFiltro);

  const onChangeFiltro = useCallback((_filtro: Partial<FiltroUnidadeComPessoas>) => {
    setFiltro((state) => ({ ...state, ..._filtro }));
  }, []);

  const resetFiltro = useCallback(() => {
    setFiltro(defaultFiltro);
  }, []);
  
  return {
    filtro,
    setFiltro,
    onChangeFiltro,
    resetFiltro,
  };
}

export default useFiltroConsultarPessoasEUnidades;
